// extracted by mini-css-extract-plugin
export default {"hero":"single-product-page_hero__sSmIL","hero__image":"single-product-page_hero__image__voiC6"};